import React, { Fragment, useState } from "react";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import Head from "../../../layout/Head";

import { courses } from "../../../Data/courses";
import { Fade } from "react-reveal";
import StudentReview from "./StudentReview";
import DevelopmentCourseRight from "./DevelopmentCourseRight";
import ScrollToTop from "../../Shear/ScrollToTop";
import { useParams } from "react-router-dom";

export const WhatTheCourse = [
  {
    title: "৬ মাসের গাইডেড জার্নি!",
    description: "একদম বিগিনার ফ্রেন্ডলি ওয়েতে আপডেটেড কারিকুলাম",
    icon: "fa-solid fa-hourglass-start",
  },
  {
    title: "১০০+ টি লাইভ ক্লাস!",
    description: "ইন্ডাস্ট্রি এক্সপার্টের কাছে শিখুন লাইভে",
    icon: "fa-solid fa-headset",
  },
  {
    title: "১৬ টি প্র্যাক্টিস প্রোজেক্ট!",
    description:
      "যা শিখছেন তা দিয়েই করে ফেলুন প্র্যাক্টিস প্রজেক্ট, ঝালাই করুন দক্ষতা",
    icon: "fa-solid fa-diagram-project",
  },
  {
    title: "সাপোর্ট ক্লাস!",
    description: "প্রয়োজনে গুগল মিটে কল করেও সমাধান করার চেষ্টা করা হবে",
    icon: "fa-solid fa-handshake-angle",
  },
  {
    title: "লাইফটাইম এক্সেস!",
    description: "ক্লাস রেকর্ডিং এ থাকবে লাইফ টাইম এক্সেস",
    icon: "fa-solid fa-photo-film",
  },
  {
    title: "জব মার্কেট গাইডলাইন!",
    description:
      "ইন্ডাস্ট্রি এক্সপার্টদের কাছে পান জব মার্কেটে প্রবেশ করার পুর্নাঙ্গ নির্দেশনা",
    icon: "fa-solid fa-file-signature",
  },
  {
    title: "মার্কেটপ্লেস গাইডলাইন!",
    description:
      "কোড ক্যানিয়নের মত মার্কেটপ্লেসে কিভাবে প্রজেক্ট সেল করবেন, পাবেন গাইডলাইন",
    icon: "fa-solid fa-file-signature",
  },
  {
    title: "সার্টিফিকেট!",
    description:
      "কোর্স শেষ করে পাবেন শেয়ারেবল কোর্স কমপ্লিশন এবং এসসমেন্ট সার্টিফিকেট",
    icon: "fa-solid fa-graduation-cap",
  },
];

const WebDevelopmentCourse = () => {
  const [open, setOpen] = useState(2);
  const { slug } = useParams();
  const courseDetails = courses.find((data) => data.slug === slug);
  return (
    <>
      <Fragment>
        <Head Title="Web Development Course" />
        <Header />
        <Fade bottom>
          <section className="py-5 max-xl:py-20 px-3 max-sm:px-10 max-xl:px-0 max-xl:max-w-[1150px] 2xl:max-w-[1330px] mx-auto">
            <div className="flex justify-center gap-10 max-lg:flex-row flex-col-reverse">
              <div className=" w-full max-lg:w-[60%]">
                <h2 className="text-[#0D1C37] text-2xl max-md:text-[42px] leading-9 max-md:leading-[53px] capitalize font-black mb-[19px]">
                  {courseDetails.title}
                </h2>
                <p className="text-[#3f3f3f]  font-roboto text-justify text-base max-sm:text-lg leading-[29px] font-normal mt-8">
                  {courseDetails.info.description}
                </p>
                <div className="pt-8 px-8 sm:px-20  border border-[#eaebfa] mt-10">
                  <button
                    onClick={() => setOpen(1)}
                    className="flex mb-8 pb-8 group w-full items-start justify-between border-b border-gray-100 text-left"
                  >
                    <div className="max-w-xl pr-5">
                      <h3 className="text-xl font-semibold text-black group-hover:text-orange-900">
                        লাইভ ক্লাস হবে?
                      </h3>
                      <p
                        className={`mt-3 text-lg text-gray-500  ${
                          open === 1 ? "block" : "hidden"
                        }`}
                      >
                        জি ক্লাসগুলো লাইভ হবে এবং ক্লাসের রেকর্ড থাকবে যারা
                        ক্লাস মিস করবেন তারা ভিডিও দেখে নিতে পারবেন
                      </p>
                    </div>
                    <div className="pt-1">
                      <span className={` ${open === 1 ? "block" : "hidden"}`}>
                        <svg
                          width="17"
                          height="3"
                          viewbox="0 0 17 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 0.045166H1.46194C1.19673 0.045166 0.942374 0.150523 0.754838 0.338059C0.567302 0.525596 0.461945 0.77995 0.461945 1.04517C0.461945 1.31038 0.567302 1.56474 0.754838 1.75227C0.942374 1.93981 1.19673 2.04517 1.46194 2.04517H15.4619C15.7272 2.04517 15.9815 1.93981 16.1691 1.75227C16.3566 1.56474 16.4619 1.31038 16.4619 1.04517C16.4619 0.77995 16.3566 0.525596 16.1691 0.338059C15.9815 0.150523 15.7272 0.045166 15.4619 0.045166Z"
                            fill="#FF460C"
                          ></path>
                        </svg>
                      </span>
                      <span className={` ${open === 1 ? "hidden" : "block"}`}>
                        <svg
                          width="17"
                          height="16"
                          viewbox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 7H9.46194V1C9.46194 0.734784 9.35659 0.48043 9.16905 0.292893C8.98151 0.105357 8.72716 0 8.46194 0C8.19673 0 7.94237 0.105357 7.75484 0.292893C7.5673 0.48043 7.46194 0.734784 7.46194 1V7H1.46194C1.19673 7 0.942374 7.10536 0.754838 7.29289C0.567302 7.48043 0.461945 7.73478 0.461945 8C0.461945 8.26522 0.567302 8.51957 0.754838 8.70711C0.942374 8.89464 1.19673 9 1.46194 9H7.46194V15C7.46194 15.2652 7.5673 15.5196 7.75484 15.7071C7.94237 15.8946 8.19673 16 8.46194 16C8.72716 16 8.98151 15.8946 9.16905 15.7071C9.35659 15.5196 9.46194 15.2652 9.46194 15V9H15.4619C15.7272 9 15.9815 8.89464 16.1691 8.70711C16.3566 8.51957 16.4619 8.26522 16.4619 8C16.4619 7.73478 16.3566 7.48043 16.1691 7.29289C15.9815 7.10536 15.7272 7 15.4619 7Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </button>
                  <button
                    onClick={() => setOpen(2)}
                    className="flex mb-8 pb-8 group w-full items-start justify-between border-b border-gray-100 text-left"
                  >
                    <div className="max-w-xl pr-5">
                      <h3 className="text-xl font-semibold text-black group-hover:text-orange-900">
                        কোথাও আটকে গেলে সহায়তা কিভাবে পাবো?
                      </h3>

                      <p
                        className={`mt-3 text-lg text-gray-500  ${
                          open === 2 ? "block" : "hidden"
                        }`}
                      >
                        কোর্স চলাকালীন যেকোন সমস্যার সম্মুখীন হলে, কোথাও আটকে
                        গেলে অথবা বুঝতে না পারলে, আপনার প্রশ্নটি আমাদের ডিসকোর্ড
                        সাপোর্ট চ্যানেলে পোস্ট করতে পারবেন। যদি ডিসকোর্ড সাপোর্ট
                        চ্যানেলের মাধ্যমে কোন জটিল সমস্যা সমাধান না করা যায়,
                        তাহলে প্রয়োজনে গুগল মিটে কল করেও সমাধান করার চেষ্টা করা
                        হবে।
                      </p>
                    </div>
                    <div className="pt-1">
                      <button
                        className={`  ${open === 2 ? "block" : "hidden"}`}
                      >
                        <svg
                          width="17"
                          height="3"
                          viewbox="0 0 17 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 0.045166H1.46194C1.19673 0.045166 0.942374 0.150523 0.754838 0.338059C0.567302 0.525596 0.461945 0.77995 0.461945 1.04517C0.461945 1.31038 0.567302 1.56474 0.754838 1.75227C0.942374 1.93981 1.19673 2.04517 1.46194 2.04517H15.4619C15.7272 2.04517 15.9815 1.93981 16.1691 1.75227C16.3566 1.56474 16.4619 1.31038 16.4619 1.04517C16.4619 0.77995 16.3566 0.525596 16.1691 0.338059C15.9815 0.150523 15.7272 0.045166 15.4619 0.045166Z"
                            fill="#FF460C"
                          ></path>
                        </svg>
                      </button>
                      <span className={`  ${open === 2 ? "hidden" : "block"}`}>
                        <svg
                          width="17"
                          height="16"
                          viewbox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 7H9.46194V1C9.46194 0.734784 9.35659 0.48043 9.16905 0.292893C8.98151 0.105357 8.72716 0 8.46194 0C8.19673 0 7.94237 0.105357 7.75484 0.292893C7.5673 0.48043 7.46194 0.734784 7.46194 1V7H1.46194C1.19673 7 0.942374 7.10536 0.754838 7.29289C0.567302 7.48043 0.461945 7.73478 0.461945 8C0.461945 8.26522 0.567302 8.51957 0.754838 8.70711C0.942374 8.89464 1.19673 9 1.46194 9H7.46194V15C7.46194 15.2652 7.5673 15.5196 7.75484 15.7071C7.94237 15.8946 8.19673 16 8.46194 16C8.72716 16 8.98151 15.8946 9.16905 15.7071C9.35659 15.5196 9.46194 15.2652 9.46194 15V9H15.4619C15.7272 9 15.9815 8.89464 16.1691 8.70711C16.3566 8.51957 16.4619 8.26522 16.4619 8C16.4619 7.73478 16.3566 7.48043 16.1691 7.29289C15.9815 7.10536 15.7272 7 15.4619 7Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </button>
                  <button
                    onClick={() => setOpen(3)}
                    className="flex mb-8 pb-8 group w-full items-start justify-between border-b border-gray-100 text-left"
                  >
                    <div className="max-w-xl pr-5">
                      <h3 className="text-xl font-semibold text-black group-hover:text-orange-900">
                        কোর্সে ভালো করলে জব রেকোমেন্ডেশন লেটার?
                      </h3>
                      <p
                        className={`mt-3 text-lg text-gray-500  ${
                          open === 3 ? "block" : "hidden"
                        }`}
                      >
                        যারা কোর্সের বিভিন্ন এসাইনমেন্ট ভাল রেজাল্ট করবেন এবং
                        সামগ্রিকভাবে কমপক্ষে 80% মার্কস পাবেন, তাদের কে নির্বাচন
                        করে আমরা জব রেকোমেন্ডেশন লেটার লিখে দিবো। এই কোর্স কাউকে
                        চাকরির নিশ্চয়তা দিতে পারবেনা কারণ কোন কোর্সই সেটা
                        পারেনা। তবে পরিশ্রমী এবং নিবেদিতপ্রাণ লার্নারদের সঠিক
                        গাইডলাইন অবশ্যই নিশ্চিত করবে এবং চাকরির ইন্টারভিউতে যেন
                        তারা আত্মবিশ্বাস এর সাথে ভাল করতে পারে সে ব্যাপারে
                        সাহায্য করবে।
                      </p>
                    </div>
                    <div className="pt-1">
                      <span className={` ${open === 3 ? "block" : "hidden"}`}>
                        <svg
                          width="17"
                          height="3"
                          viewbox="0 0 17 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 0.045166H1.46194C1.19673 0.045166 0.942374 0.150523 0.754838 0.338059C0.567302 0.525596 0.461945 0.77995 0.461945 1.04517C0.461945 1.31038 0.567302 1.56474 0.754838 1.75227C0.942374 1.93981 1.19673 2.04517 1.46194 2.04517H15.4619C15.7272 2.04517 15.9815 1.93981 16.1691 1.75227C16.3566 1.56474 16.4619 1.31038 16.4619 1.04517C16.4619 0.77995 16.3566 0.525596 16.1691 0.338059C15.9815 0.150523 15.7272 0.045166 15.4619 0.045166Z"
                            fill="#FF460C"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className={`mt-3 text-lg text-gray-500  ${
                          open === 3 ? "hidden" : "block"
                        }`}
                      >
                        <svg
                          width="17"
                          height="16"
                          viewbox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 7H9.46194V1C9.46194 0.734784 9.35659 0.48043 9.16905 0.292893C8.98151 0.105357 8.72716 0 8.46194 0C8.19673 0 7.94237 0.105357 7.75484 0.292893C7.5673 0.48043 7.46194 0.734784 7.46194 1V7H1.46194C1.19673 7 0.942374 7.10536 0.754838 7.29289C0.567302 7.48043 0.461945 7.73478 0.461945 8C0.461945 8.26522 0.567302 8.51957 0.754838 8.70711C0.942374 8.89464 1.19673 9 1.46194 9H7.46194V15C7.46194 15.2652 7.5673 15.5196 7.75484 15.7071C7.94237 15.8946 8.19673 16 8.46194 16C8.72716 16 8.98151 15.8946 9.16905 15.7071C9.35659 15.5196 9.46194 15.2652 9.46194 15V9H15.4619C15.7272 9 15.9815 8.89464 16.1691 8.70711C16.3566 8.51957 16.4619 8.26522 16.4619 8C16.4619 7.73478 16.3566 7.48043 16.1691 7.29289C15.9815 7.10536 15.7272 7 15.4619 7Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </button>

                  <button
                    onClick={() => setOpen(5)}
                    className="flex group w-full items-start pb-10 justify-between text-left"
                  >
                    <div className="max-w-xl pr-5">
                      <h3 className="text-xl font-semibold text-black group-hover:text-orange-900">
                        কোনো টেকনিকাল সমস্যা কীভাবে রিপোর্ট করব?
                      </h3>
                      <p
                        className={`mt-3 text-lg text-gray-500  ${
                          open === 5 ? "block" : "hidden"
                        }`}
                      >
                        যেকোনো সমস্যার ক্ষেত্রে, কল করুনঃ 01540343775 ইমেইল
                        করুনঃ infoitghor24@gmail.com
                      </p>
                    </div>
                    <div className="pt-1">
                      <span className={` ${open === 5 ? "block" : "hidden"}`}>
                        <svg
                          width="17"
                          height="3"
                          viewbox="0 0 17 3"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 0.045166H1.46194C1.19673 0.045166 0.942374 0.150523 0.754838 0.338059C0.567302 0.525596 0.461945 0.77995 0.461945 1.04517C0.461945 1.31038 0.567302 1.56474 0.754838 1.75227C0.942374 1.93981 1.19673 2.04517 1.46194 2.04517H15.4619C15.7272 2.04517 15.9815 1.93981 16.1691 1.75227C16.3566 1.56474 16.4619 1.31038 16.4619 1.04517C16.4619 0.77995 16.3566 0.525596 16.1691 0.338059C15.9815 0.150523 15.7272 0.045166 15.4619 0.045166Z"
                            fill="#FF460C"
                          ></path>
                        </svg>
                      </span>
                      <span className={` ${open === 5 ? "hidden" : "block"}`}>
                        <svg
                          width="17"
                          height="16"
                          viewbox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.4619 7H9.46194V1C9.46194 0.734784 9.35659 0.48043 9.16905 0.292893C8.98151 0.105357 8.72716 0 8.46194 0C8.19673 0 7.94237 0.105357 7.75484 0.292893C7.5673 0.48043 7.46194 0.734784 7.46194 1V7H1.46194C1.19673 7 0.942374 7.10536 0.754838 7.29289C0.567302 7.48043 0.461945 7.73478 0.461945 8C0.461945 8.26522 0.567302 8.51957 0.754838 8.70711C0.942374 8.89464 1.19673 9 1.46194 9H7.46194V15C7.46194 15.2652 7.5673 15.5196 7.75484 15.7071C7.94237 15.8946 8.19673 16 8.46194 16C8.72716 16 8.98151 15.8946 9.16905 15.7071C9.35659 15.5196 9.46194 15.2652 9.46194 15V9H15.4619C15.7272 9 15.9815 8.89464 16.1691 8.70711C16.3566 8.51957 16.4619 8.26522 16.4619 8C16.4619 7.73478 16.3566 7.48043 16.1691 7.29289C15.9815 7.10536 15.7272 7 15.4619 7Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div className=" w-full max-lg:w-[40%]">
                <DevelopmentCourseRight courseDetails={courseDetails} />
              </div>
            </div>

            <div>
              <h2 className="text-[#0D1C37] text-center mt-10 text-2xl max-md:text-[42px] leading-9 max-md:leading-[53px] capitalize font-black mb-[19px]">
                কোর্সটি করে যা
                <span className="text-primary"> শিখবেন</span>
              </h2>

              <div className="py-5  max-xl:px-0 max-xl:max-w-[1150px]   mx-auto w-full justify-center items-center gap-5 grid grid-cols-2 max-sm:grid-cols-3  max-md:grid-cols-4 max-lg:grid-cols-5 text-center ">
                {courseDetails.skilsIcons.map((skill) => (
                  <div
                    key={skill.id}
                    className="flex gap-4    justify-center items-center py-4 px-6 rounded"
                    style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
                  >
                    <img
                      src={skill.img}
                      alt=""
                      className="block w-[30px] max-sm:w-[40px]"
                    />
                    <span className=" font-semibold text-sm max-sm:text-base">
                      {skill.title}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <h2 className="text-[#0D1C37] text-center mt-10 text-2xl max-md:text-[42px] leading-9 max-md:leading-[53px] capitalize font-black mb-[19px]">
              কোর্সে যা
              <span className="text-primary"> থাকছে</span>
            </h2>
            <div className="py-5  max-xl:px-0 max-xl:max-w-[1150px]  mx-auto w-full justify-center items-center grid grid-cols-1 max-md:grid-cols-2 max-xl:grid-cols-4 gap-5  ">
              {WhatTheCourse.map((data, i) => (
                <div
                  key={i}
                  className="px-2 py-2 h-44 text-center flex flex-col justify-center items-center"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
                >
                  <i className={`${data.icon} text-primary text-xl `}></i>
                  <span className=" font-semibold text-base pt-5 pb-2">
                    {data.title}
                  </span>

                  <p className="text-[#868686] text-base">{data.description}</p>
                </div>
              ))}
            </div>
            <div></div>

            <StudentReview />
          </section>
        </Fade>
        <ScrollToTop />
        <Footer />
      </Fragment>
    </>
  );
};

export default WebDevelopmentCourse;
